export default __webpack_public_path__ + "static/logo-e56c88ddab6a2cc2e41701cb1be04be5.svg";